module.exports = __webpack_public_path__ + "img/3.4078e5af.png";